<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>View Final Reports for class: {{className}}</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon"
            @click="handleBackButton"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-chevron-left" />
            </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <display-final-class-report />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplayFinalClassReport from '@/components/exam/final/Report/index'

export default {
  components: {
    DisplayFinalClassReport,
  },
  data: function() {
    return {
      loading: false,
    }
  },
  computed: {
    className: function () {
      return this.$route.params.className
    },
  },
  methods: {
    handleBackButton() {
      this.$router.push({ name: 'managefinal' })
    },
  },
}
</script>
